<div class="content ingame code-game">
  <div class="chace-light" *ngIf="chaceOn"></div>
  <div class="timer-bar-wrapper" #bar *ngIf="chaceOn">
    <div class="bar" [ngStyle]="{'width': progressStr }">
      <div class="police" [ngStyle]="{'background-image': 'url(assets/images/police.png)'}" *ngIf="chaceOn"></div>
    </div>



  </div>
  <span class="chaceOn" *ngIf="chaceOn">Chace On!</span>

  <div class="main-container" [ngClass]="{'chaceOn': chaceOn}">
    <div class="led-container">
      <div class="led" #led></div>
    </div>
    <div #codeContainer>


      <div class="combination" [@topIn]>
        <code-display [(current)]="current" [digits]="game?.lock?.digits" [type]="game?.codification?.type">
        </code-display>

      </div>
      <div class="check-button">
        <button class="check button " (click)="checkCode()" (keydown.enter)="checkCode()" [disabled]="!isCurrentValid()"><i
            class="fa fa-check"></i></button>
        <button class="escape button" (click)="escape()"><i class="fa fa-sign-out "></i></button>

      </div>

    </div>

    <div class="tries-wrapper">

      <div class="tries-content">
        <div class="trie" *ngFor="let trie of tries; let i = index;" [@topIn] #trieContent>
          <digit [digit]="digit" *ngFor="let digit of trie.code; let i = index" (onDigitClick)="trie.rotateState(i)"
            [state]="trie?.state[i]" [class]="'small no-button'" [codification]="game?.codification">
          </digit>

          <div class="to-right result">
            <div class=" value ok"><span>{{trie.ok}}</span></div>
          </div>
          <div class="result ">
            <div class=" value regular"><span>{{trie.regular}}</span></div>
          </div>
          <div class="result">
            <div class=" value wrong"><span>{{trie.wrong}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-result" *ngIf="noTries" [ngClass]="{'visible': noTries}">
    <div class="game-result-wrapper">
      <div class="game-result-content">

        <div class="result" [ngClass]="{'winner': isWinner}">
          <span>NO TIENES MAS GANZUAS</span>
        </div>


        <div class="buttons">
          <button (click)="comprar()">COMPRAR</button>
          <button (click)="resign()">RENDIRSE</button>
        </div>
      </div>
    </div>

  </div>

  <div class="game-result" *ngIf="gameFinished" [ngClass]="{'visible': gameFinished}">
    <div class="game-result-wrapper">
      <div class="game-result-content">

        <div class="result" [ngClass]="{'winner': isWinner}">
          <span *ngIf="isWinner">YOU WIN!</span>
          <span *ngIf="!isWinner">YOU LOSE!</span>
        </div>
        <div class="score-content" *ngIf="isWinner">

          <div class="score"><span>Tiempo Restante </span><span class="value">{{score.stepTime}}</span></div>
          <div class="score"><span>Intentos Restantes </span><span class="value">{{score.stepTries}}</span></div>
          <div class="score"><span>Dificultad </span><span class="value">{{score.stepDifficulty}}</span></div>
          <div class="division"></div>
          <div class="score total"><span>Total </span><span class="value">{{score.stepTotal}}</span></div>
        </div>

        <div class="buttons">
          <button (click)="newGame()">NEW GAME</button>
          <button (click)="back()">GO BACK</button>
        </div>
      </div>
    </div>

  </div>

</div>
